import {Dialog} from '@primer/react'
import {useIsLoading} from '../contexts/IsLoadingContext'

type DeletionDialogProps = {
  buttonRef: React.RefObject<HTMLButtonElement | null>
  numberOfRulesets: number
  numberOfBranchProtections: number
  onCancel(): void
  onConfirm(shouldDelete: boolean): void
}

export function DeletionDialog({
  buttonRef,
  numberOfRulesets,
  numberOfBranchProtections,
  onCancel,
  onConfirm,
}: DeletionDialogProps) {
  const isLoading = useIsLoading()

  return (
    <Dialog
      title="Creating rulesets"
      width="large"
      returnFocusRef={buttonRef}
      onClose={onCancel}
      footerButtons={[
        {
          buttonType: 'default',
          content: 'Keep rules',
          onClick: _ev => onConfirm(false),
          loading: isLoading,
        },
        {
          buttonType: 'danger',
          content: 'Delete original rules',
          onClick: _ev => onConfirm(true),
          loading: isLoading,
        },
      ]}
    >
      <Dialog.Body>
        {numberOfRulesets} rulesets will be created. Would you like to delete the {numberOfBranchProtections} original
        branch protection rules now covered by rulesets?
      </Dialog.Body>
    </Dialog>
  )
}
